import { Component, Input, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy, NgZone, ContentChild, TemplateRef, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LinkComponent } from '../link'

@Component({
  standalone: true,
  selector: 'hyperkit-ellipsis',
  templateUrl: './ellipsis.component.html',
  styleUrls: ['./ellipsis.component.scss'],
  imports: [CommonModule, LinkComponent],
})
export class EllipsisComponent implements AfterViewInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);
  private zone = inject(NgZone);

  @Input() lineCount = 3
  @Input() expandedText = 'Show more'
  @Input() collapsedText = 'Show less'
  @Input() isExpanded = false

  @ContentChild('headerTemplate') headerTemplate: TemplateRef<any> | null = null

  @ViewChild('contentContainer') contentContainer!: ElementRef<HTMLDivElement>

  public isExpandable = false
  public collapseHeight = 0
  public fullHeight = 0
  private resizeObserver!: ResizeObserver

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      this.zone.run(() => this.calculateHeights())
    })

    this.resizeObserver.observe(this.contentContainer.nativeElement)
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  private calculateHeights(): void {
    const container = this.contentContainer.nativeElement

    // Assume 20px line height
    this.collapseHeight = 20 * this.lineCount

    const range = document.createRange()
    range.selectNodeContents(container)
    const rects = range.getClientRects()

    if (rects.length > 0) {
      const containerTop = container.getBoundingClientRect().top
      const lastRectBottom = rects[rects.length - 1].bottom
      this.fullHeight = lastRectBottom - containerTop
    } else {
      this.fullHeight = container.scrollHeight
    }

    const shouldBeExpandable = this.fullHeight - this.collapseHeight > 1

    if (this.isExpandable !== shouldBeExpandable) {
      this.isExpandable = shouldBeExpandable
    }

    this.cdr.markForCheck()
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded
  }

  get currentHeight(): string {
    if (!this.isExpandable || this.fullHeight === 0) return 'auto'
    return this.isExpanded ? `${this.fullHeight}px` : `${this.collapseHeight}px`
  }
}
